// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-88d9cb3a] {\n  font-size: 32px;\n  padding: 0;\n}\n.table-container[data-v-88d9cb3a] {\n  background: #ffffff;\n  -webkit-box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.0509803922);\n          box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.0509803922);\n  padding: 16px 36px 16px 36px;\n  border-radius: 8px;\n}", ""]);
// Exports
module.exports = exports;
